!function() {
  class t extends HTMLElement {
    constructor() {
      super(), this.timerInterval = null, this.daysMap = {
        sunday: 0,
        monday: 1,
        tuesday: 2,
        wednesday: 3,
        thursday: 4,
        friday: 5,
        saturday: 6
      };
    }
    connectedCallback() {
      this.defaultText = this.getAttribute("data-default-text") || "", this.countdownTextTemplate = this.getAttribute("data-countdown-text") || "", 
      this.cutoffTime = this.getAttribute("data-cutoff-time") || "19:00", this.staticMessageText = this.getAttribute("data-static-message-text") || "", 
      this.staticMessageCutoff = this.getAttribute("data-static-message-cutoff") || null;
      if (!/^\d{2}:\d{2}$/.test(this.cutoffTime)) return void console.error("Invalid cutoff time format. Expected HH:MM");
      const t = this.getAttribute("data-excluded-days") || "";
      this.excludedDays = t.toLowerCase().split(",").map(t => this.daysMap[t.trim()]).filter(t => void 0 !== t);
      const e = this.getAttribute("data-excluded-dates") || "";
      this.excludedDates = e.split(",").map(t => t.trim()).filter(t => t), this.startCountdown();
    }
    disconnectedCallback() {
      this.timerInterval && clearInterval(this.timerInterval);
    }
    isExcluded(t) {
      if (this.excludedDays.includes(t.getDay())) return !0;
      const e = t.getFullYear() + "-" + String(t.getMonth() + 1).padStart(2, "0") + "-" + String(t.getDate()).padStart(2, "0");
      return !!this.excludedDates.includes(e);
    }
    t(t, e) {
      if (!window.strings || !window.strings.date_time || !window.strings.date_time[t]) return `${e} ${t}`;
      return (1 === e ? window.strings.date_time[t].one : window.strings.date_time[t].other).replace("{{ count }}", e);
    }
    startCountdown() {
      const t = () => {
        const t = new Date;
        if (this.staticMessageCutoff && this.staticMessageText) {
          const e = new Date(this.staticMessageCutoff);
          if (!isNaN(e.getTime()) && t <= e) {
            const t = this.formatCutoffDate(e);
            return this.innerHTML = this.staticMessageText.replace("{cutoff}", `<span>${t}</span>`), 
            this.classList.remove("hidden"), void this.disconnectedCallback();
          }
        }
        const e = new Date, [s, i] = this.cutoffTime.split(":");
        e.setHours(s, i);
        const a = e - t;
        if (!e || isNaN(a)) return this.disconnectedCallback(), this.innerHTML = this.defaultText, 
        this.classList.remove("hidden"), !1;
        if (a <= 0) return;
        const n = 6e4, r = 36e5, o = 864e5, d = Math.floor(a / o), u = Math.floor(a % o / r), c = Math.floor(a % r / n), l = Math.floor(a % n / 1e3);
        let h = [];
        c < 1 ? h.push(this.t("seconds", l)) : (d > 0 && h.push(this.t("days", d)), (u > 0 || d > 0) && h.push(this.t("hours", u)), 
        h.push(this.t("minutes", c)));
        const f = h.join(" "), m = this.countdownTextTemplate.replace("{countdown}", `<span>${f}</span>`);
        this.innerHTML = m, this.classList.remove("hidden");
      };
      t(), this.timerInterval = setInterval(t, 1e3);
    }
    getOrdinalSuffix(t) {
      const e = t % 100;
      if (e >= 11 && e <= 13) return "th";
      switch (t % 10) {
       case 1:
        return "st";

       case 2:
        return "nd";

       case 3:
        return "rd";

       default:
        return "th";
      }
    }
    formatCutoffDate(t) {
      const e = document.documentElement.lang || navigator.language || "en-GB", s = new Intl.DateTimeFormat(e, {
        weekday: "long"
      }).format(t), i = new Intl.DateTimeFormat(e, {
        month: "long"
      }).format(t), a = t.getDate();
      return `${s} ${a}${this.getOrdinalSuffix(a)} ${i}`;
    }
  }
  customElements.define("delivery-countdown", t);
}();